export default (obj, numCopies) => {
  const arr = Array(numCopies).fill()
  return arr.map((_, id) => ({ ...obj, id }))
}
